module.exports = "/images/marking-icon-draw.svg?50ce04ff33f192a259125b67888b9798";